import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NbAuthComponent } from '@nebular/auth';

import { RegisterComponent } from './pages/register/register.component';
import { LogoutComponent } from './pages/login/logout.component';
import { LoginComponent } from './pages/login/login.component';
import { ContentReleaseComponent } from './pages/content-release/content-release.component';

const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () =>
      import('../app/pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'auth',
    component: NbAuthComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'register',
        component: RegisterComponent,
      },
      {
        path: 'release',
        component: ContentReleaseComponent,
      },
    ],
  },
  {
    path: 'release',
    redirectTo: 'auth/release',
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: `reload` })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
